<style lang="scss">
  @import "@/assets/scss/vuexy/pages/List.scss";
</style>

<template>
  <div id="data-list-list-view" class="data-list-container mt-2 px-">
    <vs-button @click="goToAdd()" class="bg-primary float-right" type="filled">{{$t("Labels.Add")}}</vs-button>
    <vs-table search v-if="response" :data="response"
      @selected="goToDetail">
      <template slot="thead">
        <vs-th sort-key="name">
          {{$t('Labels.Name')}}
        </vs-th>
        <vs-th sort-key="type">
          {{$t('Labels.Type')}}
        </vs-th>
        <vs-th sort-key="port">
          {{$t('Labels.Port')}}
        </vs-th>
        <vs-th sort-key="app_id">
          {{$tc('Labels.App',1)}}
        </vs-th>
        <vs-th sort-key="device_profile_uuid">
          {{$t('Labels.Profile')}}
        </vs-th>
        <vs-th sort-key="updated_at">
          {{$t('Labels.UpdatedAt')}}
        </vs-th>
      </template>

      <template  slot-scope="{data}">
        <vs-tr :data="item" :key="index" v-for="(item, index) in data" >
          <vs-td :data="item.name">
            {{item.name}}
          </vs-td>
          <vs-td :data="item.type">
            {{item.type}}
          </vs-td>
          <vs-td :data="item.port">
            {{item.port}}
          </vs-td>
          <vs-td :data="item.app_id">
            {{item.app_id}}
          </vs-td>
          <vs-td :data="item.device_profile_uuid">
            {{item.device_profile_uuid}}
          </vs-td>
          <vs-td :data="item.updated_at">
            {{item.updated_at}}
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    </vs-table>
  </div>
</template>

<script>
import {request} from '@/request.js'

export default {
  components: {
  },
  data () {
    return {
      isMounted: false,
      response: [],
      currentx: 1,
      active:false,
      totalPages: 0,
      oldCurrentPage: 1,
      filter:{
        name:''
      }
    }
  },

  computed: {
    currentPage () {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    }
  },


  methods: {
    async getResponse () {
      this.$vs.loading()

      const params = {
        url: 'device_types',
        method: 'GET',
        params:{}
      }
      await request(params).then(response => {
        this.response = response.data.data
      }).finally(() => {
        this.$vs.loading.close()
      })
    },
    async getActualizar () {
      const loading = this.$vs.loading()
      const params = {
        url: 'device_types',
        params:{
          name: this.filter.name
        },
        method: 'GET'
      }
      await request(params).then(response => {
        this.response = response.data.data.rows
        this.totalPages = response.data.data.count
      }).finally(() => {
        loading.close()
      })
    },

    goToDetail (tr) {
      window.location.href = `/types/${tr.uuid}`
    },
    goToAdd () {
      window.location.href = '/types/add'
    }
  },

  created () {
    this.$route.meta.breadcrumb[1].title = this.$t('Path.DeviceTypes')
    this.$route.meta.breadcrumb[2].title = this.$t('Path.List')
    this.$route.meta.pageTitle = this.$t('Path.List')
    this.$router.replace({query: {temp: Date.now()}})
    this.$router.replace({query: {temp: undefined}})
    this.getResponse()
  },

  mounted () {
    this.isMounted = true
  },

  updated () {
    if (this.oldCurrentPage != this.currentx) {
      this.oldCurrentPage = this.currentx
      this.getActualizar()
    }
  }
}
</script>
